/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SeatInfo { 
    id?: number;
    ticketId?: number;
    row?: string;
    place?: string;
    priceClass?: number;
    bookingId?: number;
    seatStatus?: SeatInfo.SeatStatusEnum;
}
export namespace SeatInfo {
    export type SeatStatusEnum = 'booked' | 'sold' | 'available';
    export const SeatStatusEnum = {
        Booked: 'booked' as SeatStatusEnum,
        Sold: 'sold' as SeatStatusEnum,
        Available: 'available' as SeatStatusEnum
    };
}


